import React from 'react';

export const FormField = ({ label, error, required, children }) => (
  <div>
    <label className="block text-sm font-medium text-slate-700 mb-1">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    {children}
    {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
  </div>
);

export const inputClass = (error) =>
  `w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-slate-900 focus:border-slate-900 outline-none transition-colors ${
    error ? 'border-red-400 bg-red-50' : 'border-slate-300'
  }`;